import React, { Component } from 'react';
import iconTrello from "../../assets/cards/icon_trello.svg"
import Snackbar from '@material-ui/core/Snackbar';
import { withRouter } from "react-router-dom";
import { withFirebase } from '../Firebase';
import * as request from 'request'
import Modal from "react-responsive-modal";
import trelloGrey from '../../assets/cards/iconTrelloGrey.svg';
import trelloBlue from '../../assets/cards/iconTrelloBleu.svg';
import "./CreateTrelloBoard.css";
import Tooltip from '@material-ui/core/Tooltip';
import { ActivateCapsuleModalForm } from './ProgressCapsules/ActivateCapsuleModalContent';

class CreateTrelloComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { token: undefined, openSnack: false, message: "", idList: "", ideas: [], calendarOpen: false, activeForProgressCards: this.props.activeForProgressCards, onTrelloLocal: false }
    }

    componentDidMount() {
        let trello_token = localStorage.getItem('token');
        this.setState({ token: trello_token });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activeForProgressCards !== this.state.activeForProgressCards) {
            this.setState({ activeForProgressCards: nextProps.activeForProgressCards })
        }
    }

    notConnected = () => {
        this.setState({ openSnack: true });
        this.setState({ message: "Vous n'êtes pas connecté a trello merci de vous connecter dans Mon compte" })
    }


    openCalendar = () => {
        const { capsule } = this.props
        const { onTrelloLocal } = this.state

        let message
        if ((capsule.onTrello && capsule.onTrello === true) || onTrelloLocal === true) {
            message = "Cette capsule est déjà sur Trello"
            if (this.state.activeForProgressCards === true) {
                this.props.changeLocalStatus("begin")
                this.setState({
                    activeForProgressCards: false,
                    message: message,
                    openSnack: true
                })
                this.props.firebase.db
                    .collection("capsules")
                    .doc(capsule.id)
                    .update({ status: "begin" });
            }
        }
        else {
            this.setState({
                calendarOpen: true,
            })
        }
    }

    closeCalendar = (result) => {
        this.setState({
            calendarOpen: false
        })
        if (result === 'success') {
            this.createBoard();
            if (this.state.activeForProgressCards === true) {
                this.props.changeLocalStatus("begin")
                this.setState({
                    activeForProgressCards: false
                })
            }
        }
    }

    handleClose = () => {
        this.setState({ openSnack: false });
    }


    getListTrello = (body, token, onSuccess) => {
        let url = "https://api.trello.com/1/boards/" + body + "/lists"
        let auth = "?key=0f801328c5eb1a3e5afd86b655b17534&token=" + token
        let url_getlist = url + auth;
        let jsonbody;
        var options = {
            method: 'GET',
            url: url_getlist,
            qs:
            {
                cards: 'none',
                card_fields: 'all',
                filter: 'open',
                fields: 'all'
            }
        };
        request(options, function (error, response, body) {
            jsonbody = JSON.parse(body)
            onSuccess(jsonbody[0].id)
            if (error) throw new Error(error);
        });
    }

    createTrelloBoard = (token, onSuccess) => {
        let string_url = "https://api.trello.com/1/boards?key=0f801328c5eb1a3e5afd86b655b17534&token=" + token;
        var request = require("request");
        let jsonbody;

        var options = {
            method: 'POST',
            url: string_url,
            qs:
            {
                name: this.props.capsuleName,
                defaultLabels: 'true',
                defaultLists: 'true',
                keepFromSource: 'none',
                prefs_permissionLevel: 'private',
                prefs_voting: 'disabled',
                prefs_comments: 'members',
                prefs_invitations: 'members',
                prefs_selfJoin: 'true',
                prefs_cardCovers: 'true',
                prefs_background: 'blue',
                prefs_cardAging: 'regular'
            }
        };

        return request(options, function (error, response, body) {
            jsonbody = JSON.parse(body)
            onSuccess(jsonbody.id)
        })
    }

    createBoard = async () => {
        const { token } = this.state
        const { capsuleId, currentUserId } = this.props
        let message;
        this.props.firebase.db.collection('capsules').doc(capsuleId).update({ assigneeId: currentUserId, activatorId: currentUserId, activationDate: new Date().getTime() })

        if (token) {
            message = "Vous avez bien ajouté votre capsule a trello";
            await this.createTrelloBoard(token, this.listBoard)
            this.props.firebase.db.collection('capsules').doc(capsuleId).update({ onTrello: true })
            this.setState({ onTrelloLocal: true })
        } else {
            message = "Vous n'êtes pas connecté a trello merci de vous connecter dans";
        }

        this.setState({ message: message, openSnack: true });
    }

    addCardIdeas = (listId, token) => {
        this.props.firebase.db
            .collection('capsules')
            .doc(this.props.capsuleId)
            .collection('ideas')
            .get()
            .then(querysnapshot => {
                let ideas = querysnapshot.docs.map(doc => {
                    let data = doc.data()
                    return {
                        id: doc.id,
                        ...data
                    }
                });
                this.setState({ ideas: ideas })

                this.saveIdeas(ideas, listId, token)
            })
    }

    addCardAttachments = async (listId, token) => {

        let querySnap = await this.props.firebase.db
            .collection('capsules')
            .doc(this.props.capsuleId)
            .get()

        let capsule = querySnap.data()
        let attachments = capsule.attachments || []

        let string_url = "https://api.trello.com/1/cards?key=0f801328c5eb1a3e5afd86b655b17534&token=" + token;

        var options = {
            method: 'POST',
            url: string_url,
            qs: {
                idList: listId,
                name: "Pièces jointes",
                keepFromSource: 'all'
            }
        };
        request(options, function (error, response, body) {
            if (error) throw new Error(error);
            let jsonBody = JSON.parse(body)
            let cardId = jsonBody.id

            attachments.forEach((attachment) => {

                let url = `https://api.trello.com/1/cards/${cardId}/attachments?key=0f801328c5eb1a3e5afd86b655b17534&token=${token}`

                const options = {
                    method: 'POST',
                    url,
                    qs: {
                        name: attachment.fileName,
                        url: attachment.url
                    }
                }

                request(options, function (error, response, body) {

                })

            })
        });
    }

    saveIdeas = (ideas, listId, token) => {

        let string_url = "https://api.trello.com/1/cards?key=0f801328c5eb1a3e5afd86b655b17534&token=" + token;

        ideas.forEach((idea) => {
            var options = {
                method: 'POST',
                url: string_url,
                qs: {
                    idList: listId,
                    name: idea.description_idea,
                    desc: idea.description_idea,
                    keepFromSource: 'all'
                }
            };
            request(options, function (error, response, body) {
                if (error) throw new Error(error);
            });
        })
    }

    listBoard = async (boardId) => {
        const { token } = this.state;
        localStorage.setItem('boardTrello', boardId);
        this.getListTrello(boardId, token, this.idListBoard)
    }

    idListBoard = async (listId) => {
        const { token } = this.state;
        this.addCardIdeas(listId, token)
        this.addCardAttachments(listId, token)
    }

    render() {
        const { message, token, calendarOpen, activeForProgressCards } = this.state
        const { assigneeId, loading, capsuleId, forProgressCards, user } = this.props
        const active = this.props.active === undefined ? true : this.props.active

        let action = (
            <a href="/account" style={{ color: 'white', textDecoration: 'underline' }}>Mon compte</a>
        );

        if (token) {
            action = <></>
        }

        return (
            <>
                {loading && !forProgressCards ? <img className='trello-button-disabled' src={iconTrello} alt="trello" /> : null}

                {!loading && !forProgressCards ?
                    (active ?
                        (assigneeId === null || !assigneeId ?
                            <Tooltip title="Envoyer sur Trello" aria-label="trello">
                                <img onClick={this.openCalendar} className='trello-button-create' src={iconTrello} alt="trello" />
                            </Tooltip> :
                            <img className='trello-button-disabled' src={iconTrello} alt="trello" />) :
                        <img className='trello-button-disabled' src={iconTrello} alt="trello" />) :
                    null}

                {forProgressCards ?
                    (activeForProgressCards ?
                        <Tooltip title="Envoyer sur Trello" aria-label="trello">
                            <img className="cursor-pointer" alt="fuseeGrey" onClick={this.openCalendar} src={trelloGrey} />
                        </Tooltip>
                        :
                        <Tooltip title="Envoyer sur Trello" aria-label="trello">
                            <img className="cursor-pointer" alt="fuseeBlue" src={trelloBlue} />
                        </Tooltip>
                    ) :
                    null
                }
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.openSnack}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                    message={<span id="message-id">{message}</span>}
                    action={action}
                />
                <Modal
                    open={calendarOpen}
                    onClose={this.closeCalendar}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_calendar : styles_mobile}
                >
                    <ActivateCapsuleModalForm
                        onClose={this.closeCalendar}
                        capsuleID={capsuleId}
                        user={user}
                    />

                </Modal>
            </>
        )
    }
}

const styles_calendar = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "650px",
        maxWidth: "395px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};

export default withRouter(withFirebase(CreateTrelloComponent));